import axios from 'axios';
import { authHeader } from '../_helpers';
import config from '../_helpers/_config';

export const projectService = {
    getUserProjects,
    getProjectInfo,
    getProjectLazyInfoDisplay,
    getProjectLazyInfoModule,
    getProjectWatchdog
};

async function getUserProjects(id) {
    const req_config = {
        headers: authHeader()
    };

    return axios.get(`${config.API_LOCATION}/project/userlist/${id}`, req_config);
}

async function getProjectInfo(projectId) {
    const req_config = {
        headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
    };

    return await axios.get(`${config.API_LOCATION}/project/info/viewer`, req_config);
}

async function getProjectLazyInfoDisplay(projectId, displayId) {
  const req_config = {
    headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
  };

  return await axios.get(`${config.API_LOCATION}/project/info/viewer/display/${displayId}`, req_config);
}

async function getProjectLazyInfoModule(projectId, moduleId) {
  const req_config = {
    headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
  };

  return await axios.get(`${config.API_LOCATION}/project/info/viewer/module/${moduleId}`, req_config);
}

async function getProjectWatchdog(projectId, stationId) {
  const req_config = {
    headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
  };

  return await axios.get(`${config.API_LOCATION}/project/info/viewer/watchdog/${stationId}`, req_config);
}
